<template>
    <span  v-on:click="inputChange" v-bind:class="{ 'multi-select' : selectionType == 1, 'selected' : quantity > 0, 'buyButtonDisabled' : buybuttonDisabled, 'product-item-extra sly-item' : selectionType !== 'mandatory', 'product-item-mandatory' : selectionType === 'mandatory'  }">
        <label>
            <span class="product-item-extra-inner">

                <span v-if="product.content.photos != null" class="image-container" :style="{ backgroundImage: `url('${product.content.photos[0]}')`,  'pointer-events': 'none'  }"></span>
                <span v-else class="image-container"></span>

                <span class="number-spinner-wrp" v-if="useMaximum">
                    <span class="number-spinner">
                        <span class="min" :class="{ disabled: quantity==0 }" v-if="quantity > 0" v-on:click.stop="addQuantity(-1)">-</span>
                        <span class="spinner" v-if="quantity > 0">{{quantity}}</span>
                        <span class="plus" :class="{ disabled: maximumReached }" v-on:click.stop="addQuantity(1)">+</span>
                    </span>
                </span>

                <span v-if="!useMaximum && selectionType === 'radio'" class="radiobox" v-bind:class="quantity ? 'active' : '' ">
                    <i class="icon icon-radio"></i>
                </span>
                <span v-if="!useMaximum && selectionType !== 'radio' && selectionType !== 'mandatory'" class="checkbox" v-bind:class="quantity ? 'active' : '' ">
                    <i class="icon icon-check"></i>
                </span>

                <span class="caption">{{product.name}}</span> 
                <span v-if="product.price.priceInclTax > 0 && selectionType !== 'mandatory'" class="price">(+ {{product.price.priceInclTax | toCurrency}})</span>
                <span v-if="product.price.priceInclTax <0 && selectionType !== 'mandatory'" class="price">({{product.price.priceInclTax | toCurrency}})</span>
            </span>
        </label>
    </span>
</template>

<script>
    import { services } from '../Services/Services'

    export default {

        props: {
            /** The product id of this item*/
            'productId': Number,
            /** the selection type of this item (radio/checkbox) */
            'selectionType': String,
            /** the list index of this item */
            'listIndex': Number,
            /** The quantity of this item */
            "quantity": Number,
            /** A value indicating wheter the quantity can be increased or not */
            'maximumReached': Boolean,
            /** A value indicating wheter to use the maximum value or not (grouped maximum) */
            'useMaximum': Boolean
        },
        computed: {
            product: function () {
                return services.getProductExtra(this.productId);
            },
            buybuttonDisabled: function () {
                return (this.product.buyButtonDisabled || this.maximumReached) && this.quantity == 0;
            }
        },
        methods: {
            inputChange: function () {

                if (this.buybuttonDisabled) {
                    return;
                }
                if (this.selectionType == 'mandatory') {
                    return;
                }

                /// this.quantity = this.quantity === 0 ? 1 : 0;
                // toggle function
                this.$emit('extra-quantity-changed', { extraQuantity: (!this.quantity || this.quantity == 0) ? 1 : 0, extraId: this.productId, selectionType: this.selectionType });
            },
            addQuantity: function (q) {

                if (this.selectionType == 'mandatory') {
                    return;
                }
                if (this.buybuttonDisabled) {
                    return;
                }

                if (this.maximumReached && q > 0) {
                    return;
                }
                if (this.quantity == 0 && q < 0) {
                    return;
                }

                this.quantity += q;
                this.$emit('extra-quantity-changed', { extraQuantity: this.quantity, extraId: this.productId, selectionType: this.selectionType });


            }
        },

        created: function () {
            if (this.product.content.preselected && !this.product.buyButtonDisabled) {
                this.quantity = 1;
                this.$emit('extra-quantity-changed', { extraQuantity: 1, extraId: this.productId, selectionType: this.selectionType });
            }
        }
    }


</script>



// WEBPACK FOOTER //
// Vue/Src/Components/order-item-extra.vue